import React, { FC } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox } from '@mui/material';
import { FastField } from 'formik';
import { InputFieldConditionalRendering } from 'src/components/conditional-rendering/InputFieldConditionalRendering';

interface CheckboxProps {
  disabled?: boolean;
  fieldName: string;
  label: string;
  formik?: any; // Making without a Formik prop will use FastField with context.
  size?: 'small' | 'medium';
  placement?: 'start' | 'end' | 'top' | 'bottom';
}

export const CheckboxField: FC<CheckboxProps> = ({ disabled, fieldName, label, formik, size }) => {
  if (formik) {
    return (
      <FormControlLabel
        {...formik.getFieldProps(fieldName)}
        checked={formik.values[fieldName]}
        onChange={formik.handleChange}
        disabled={disabled}
        control={<Checkbox size={size} data-cy={fieldName + '-field'} />}
        label={label}
        margin="normal"
      />
    );
  }
  return (
    <InputFieldConditionalRendering fieldName={fieldName}>
      <FastField name={fieldName}>
        {(fieldInfo: any) => {
          const { field } = fieldInfo;
          return (
            <FormControlLabel
              checked={field.value ?? false}
              {...field}
              value={field.value ?? false}
              disabled={disabled}
              control={<Checkbox data-cy={fieldName + '-field'} size={size} />}
              label={label}
            />
          );
        }}
      </FastField>
    </InputFieldConditionalRendering>
  );
};
